import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateRoadmap400,
  CreateRoadmap401,
  CreateRoadmap500,
  CreateRoadmapBody,
  DeleteRoadmap401,
  DeleteRoadmap403,
  DeleteRoadmap404,
  DeleteRoadmap500,
  GetRoadmapDetail200,
  GetRoadmapDetail404,
  GetRoadmapDetail500,
  GetRoadmaps200,
  GetRoadmaps400,
  GetRoadmaps500,
  GetRoadmapsParams,
  ReportRoadmap201,
  ReportRoadmap400,
  ReportRoadmap401,
  ReportRoadmap404,
  ReportRoadmap500,
  ReportRoadmapBody,
  SubscribeRoadmap401,
  SubscribeRoadmap403,
  SubscribeRoadmap404,
  SubscribeRoadmap409,
  SubscribeRoadmap500,
  UnsubscribeRoadmap401,
  UnsubscribeRoadmap403,
  UnsubscribeRoadmap404,
  UnsubscribeRoadmap500,
  UpdateRoadmap400,
  UpdateRoadmap401,
  UpdateRoadmap403,
  UpdateRoadmap404,
  UpdateRoadmap500,
  UpdateRoadmapBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 필터링, 정렬, 페이지네이션을 지원하는 로드맵 목록을 조회합니다.
 * @summary 로드맵 목록 조회
 */
export const getRoadmaps = (
    params?: GetRoadmapsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetRoadmaps200>(
      {url: `/api/roadmaps`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRoadmapsQueryKey = (params?: GetRoadmapsParams,) => {
    return [`/api/roadmaps`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRoadmapsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getRoadmaps>>, TError = GetRoadmaps400 | GetRoadmaps500>(params?: GetRoadmapsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRoadmaps>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoadmapsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoadmaps>>> = ({ signal }) => getRoadmaps(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRoadmaps>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRoadmapsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRoadmaps>>>
export type GetRoadmapsInfiniteQueryError = GetRoadmaps400 | GetRoadmaps500

/**
 * @summary 로드맵 목록 조회
 */
export const useGetRoadmapsInfinite = <TData = Awaited<ReturnType<typeof getRoadmaps>>, TError = GetRoadmaps400 | GetRoadmaps500>(
 params?: GetRoadmapsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRoadmaps>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRoadmapsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetRoadmapsQueryOptions = <TData = Awaited<ReturnType<typeof getRoadmaps>>, TError = GetRoadmaps400 | GetRoadmaps500>(params?: GetRoadmapsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoadmaps>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoadmapsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoadmaps>>> = ({ signal }) => getRoadmaps(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoadmaps>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRoadmapsQueryResult = NonNullable<Awaited<ReturnType<typeof getRoadmaps>>>
export type GetRoadmapsQueryError = GetRoadmaps400 | GetRoadmaps500

/**
 * @summary 로드맵 목록 조회
 */
export const useGetRoadmaps = <TData = Awaited<ReturnType<typeof getRoadmaps>>, TError = GetRoadmaps400 | GetRoadmaps500>(
 params?: GetRoadmapsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoadmaps>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRoadmapsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 제목, 설명, 강의 목록을 포함하는 새 로드맵을 생성합니다.
 * @summary 새 로드맵 생성
 */
export const createRoadmap = (
    createRoadmapBody: CreateRoadmapBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<string>(
      {url: `/api/roadmaps`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRoadmapBody
    },
      options);
    }
  


export const getCreateRoadmapMutationOptions = <TError = CreateRoadmap400 | CreateRoadmap401 | CreateRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoadmap>>, TError,{data: CreateRoadmapBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createRoadmap>>, TError,{data: CreateRoadmapBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRoadmap>>, {data: CreateRoadmapBody}> = (props) => {
          const {data} = props ?? {};

          return  createRoadmap(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRoadmapMutationResult = NonNullable<Awaited<ReturnType<typeof createRoadmap>>>
    export type CreateRoadmapMutationBody = CreateRoadmapBody
    export type CreateRoadmapMutationError = CreateRoadmap400 | CreateRoadmap401 | CreateRoadmap500

    /**
 * @summary 새 로드맵 생성
 */
export const useCreateRoadmap = <TError = CreateRoadmap400 | CreateRoadmap401 | CreateRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoadmap>>, TError,{data: CreateRoadmapBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createRoadmap>>,
        TError,
        {data: CreateRoadmapBody},
        TContext
      > => {

      const mutationOptions = getCreateRoadmapMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 로드맵의 상세 정보를 조회합니다.
 * @summary 로드맵 상세 조회
 */
export const getRoadmapDetail = (
    roadmapId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetRoadmapDetail200>(
      {url: `/api/roadmaps/${roadmapId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRoadmapDetailQueryKey = (roadmapId: string,) => {
    return [`/api/roadmaps/${roadmapId}`] as const;
    }

    
export const getGetRoadmapDetailInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getRoadmapDetail>>, TError = GetRoadmapDetail404 | GetRoadmapDetail500>(roadmapId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRoadmapDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoadmapDetailQueryKey(roadmapId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoadmapDetail>>> = ({ signal }) => getRoadmapDetail(roadmapId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(roadmapId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRoadmapDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRoadmapDetailInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRoadmapDetail>>>
export type GetRoadmapDetailInfiniteQueryError = GetRoadmapDetail404 | GetRoadmapDetail500

/**
 * @summary 로드맵 상세 조회
 */
export const useGetRoadmapDetailInfinite = <TData = Awaited<ReturnType<typeof getRoadmapDetail>>, TError = GetRoadmapDetail404 | GetRoadmapDetail500>(
 roadmapId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRoadmapDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRoadmapDetailInfiniteQueryOptions(roadmapId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetRoadmapDetailQueryOptions = <TData = Awaited<ReturnType<typeof getRoadmapDetail>>, TError = GetRoadmapDetail404 | GetRoadmapDetail500>(roadmapId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoadmapDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoadmapDetailQueryKey(roadmapId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoadmapDetail>>> = ({ signal }) => getRoadmapDetail(roadmapId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(roadmapId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoadmapDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRoadmapDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getRoadmapDetail>>>
export type GetRoadmapDetailQueryError = GetRoadmapDetail404 | GetRoadmapDetail500

/**
 * @summary 로드맵 상세 조회
 */
export const useGetRoadmapDetail = <TData = Awaited<ReturnType<typeof getRoadmapDetail>>, TError = GetRoadmapDetail404 | GetRoadmapDetail500>(
 roadmapId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoadmapDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRoadmapDetailQueryOptions(roadmapId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 특정 로드맵의 정보를 수정합니다. 로드맵 소유자만 수정할 수 있습니다.
 * @summary 로드맵 수정
 */
export const updateRoadmap = (
    roadmapId: string,
    updateRoadmapBody: UpdateRoadmapBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<string>(
      {url: `/api/roadmaps/${roadmapId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRoadmapBody
    },
      options);
    }
  


export const getUpdateRoadmapMutationOptions = <TError = UpdateRoadmap400 | UpdateRoadmap401 | UpdateRoadmap403 | UpdateRoadmap404 | UpdateRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoadmap>>, TError,{roadmapId: string;data: UpdateRoadmapBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRoadmap>>, TError,{roadmapId: string;data: UpdateRoadmapBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRoadmap>>, {roadmapId: string;data: UpdateRoadmapBody}> = (props) => {
          const {roadmapId,data} = props ?? {};

          return  updateRoadmap(roadmapId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoadmapMutationResult = NonNullable<Awaited<ReturnType<typeof updateRoadmap>>>
    export type UpdateRoadmapMutationBody = UpdateRoadmapBody
    export type UpdateRoadmapMutationError = UpdateRoadmap400 | UpdateRoadmap401 | UpdateRoadmap403 | UpdateRoadmap404 | UpdateRoadmap500

    /**
 * @summary 로드맵 수정
 */
export const useUpdateRoadmap = <TError = UpdateRoadmap400 | UpdateRoadmap401 | UpdateRoadmap403 | UpdateRoadmap404 | UpdateRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoadmap>>, TError,{roadmapId: string;data: UpdateRoadmapBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateRoadmap>>,
        TError,
        {roadmapId: string;data: UpdateRoadmapBody},
        TContext
      > => {

      const mutationOptions = getUpdateRoadmapMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 로드맵을 삭제합니다. 로드맵 소유자만 삭제할 수 있습니다.
 * @summary 로드맵 삭제
 */
export const deleteRoadmap = (
    roadmapId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/roadmaps/${roadmapId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRoadmapMutationOptions = <TError = DeleteRoadmap401 | DeleteRoadmap403 | DeleteRoadmap404 | DeleteRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoadmap>>, TError,{roadmapId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRoadmap>>, TError,{roadmapId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRoadmap>>, {roadmapId: string}> = (props) => {
          const {roadmapId} = props ?? {};

          return  deleteRoadmap(roadmapId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoadmapMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRoadmap>>>
    
    export type DeleteRoadmapMutationError = DeleteRoadmap401 | DeleteRoadmap403 | DeleteRoadmap404 | DeleteRoadmap500

    /**
 * @summary 로드맵 삭제
 */
export const useDeleteRoadmap = <TError = DeleteRoadmap401 | DeleteRoadmap403 | DeleteRoadmap404 | DeleteRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoadmap>>, TError,{roadmapId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteRoadmap>>,
        TError,
        {roadmapId: string},
        TContext
      > => {

      const mutationOptions = getDeleteRoadmapMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 현재 로그인한 사용자가 특정 로드맵의 구독을 취소합니다.
 * @summary 로드맵 구독 취소
 */
export const unsubscribeRoadmap = (
    roadmapId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/roadmaps/${roadmapId}/subscription`, method: 'DELETE'
    },
      options);
    }
  


export const getUnsubscribeRoadmapMutationOptions = <TError = UnsubscribeRoadmap401 | UnsubscribeRoadmap403 | UnsubscribeRoadmap404 | UnsubscribeRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeRoadmap>>, TError,{roadmapId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unsubscribeRoadmap>>, TError,{roadmapId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsubscribeRoadmap>>, {roadmapId: string}> = (props) => {
          const {roadmapId} = props ?? {};

          return  unsubscribeRoadmap(roadmapId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnsubscribeRoadmapMutationResult = NonNullable<Awaited<ReturnType<typeof unsubscribeRoadmap>>>
    
    export type UnsubscribeRoadmapMutationError = UnsubscribeRoadmap401 | UnsubscribeRoadmap403 | UnsubscribeRoadmap404 | UnsubscribeRoadmap500

    /**
 * @summary 로드맵 구독 취소
 */
export const useUnsubscribeRoadmap = <TError = UnsubscribeRoadmap401 | UnsubscribeRoadmap403 | UnsubscribeRoadmap404 | UnsubscribeRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeRoadmap>>, TError,{roadmapId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof unsubscribeRoadmap>>,
        TError,
        {roadmapId: string},
        TContext
      > => {

      const mutationOptions = getUnsubscribeRoadmapMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 현재 로그인한 사용자가 특정 로드맵을 구독합니다.
 * @summary 로드맵 구독
 */
export const subscribeRoadmap = (
    roadmapId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/roadmaps/${roadmapId}/subscription`, method: 'POST'
    },
      options);
    }
  


export const getSubscribeRoadmapMutationOptions = <TError = SubscribeRoadmap401 | SubscribeRoadmap403 | SubscribeRoadmap404 | SubscribeRoadmap409 | SubscribeRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeRoadmap>>, TError,{roadmapId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof subscribeRoadmap>>, TError,{roadmapId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribeRoadmap>>, {roadmapId: string}> = (props) => {
          const {roadmapId} = props ?? {};

          return  subscribeRoadmap(roadmapId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubscribeRoadmapMutationResult = NonNullable<Awaited<ReturnType<typeof subscribeRoadmap>>>
    
    export type SubscribeRoadmapMutationError = SubscribeRoadmap401 | SubscribeRoadmap403 | SubscribeRoadmap404 | SubscribeRoadmap409 | SubscribeRoadmap500

    /**
 * @summary 로드맵 구독
 */
export const useSubscribeRoadmap = <TError = SubscribeRoadmap401 | SubscribeRoadmap403 | SubscribeRoadmap404 | SubscribeRoadmap409 | SubscribeRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeRoadmap>>, TError,{roadmapId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof subscribeRoadmap>>,
        TError,
        {roadmapId: string},
        TContext
      > => {

      const mutationOptions = getSubscribeRoadmapMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 부적절한 로드맵을 신고합니다.
 * @summary 로드맵 신고
 */
export const reportRoadmap = (
    roadmapId: string,
    reportRoadmapBody: ReportRoadmapBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ReportRoadmap201>(
      {url: `/api/roadmaps/${roadmapId}/report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportRoadmapBody
    },
      options);
    }
  


export const getReportRoadmapMutationOptions = <TError = ReportRoadmap400 | ReportRoadmap401 | ReportRoadmap404 | ReportRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportRoadmap>>, TError,{roadmapId: string;data: ReportRoadmapBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reportRoadmap>>, TError,{roadmapId: string;data: ReportRoadmapBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportRoadmap>>, {roadmapId: string;data: ReportRoadmapBody}> = (props) => {
          const {roadmapId,data} = props ?? {};

          return  reportRoadmap(roadmapId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReportRoadmapMutationResult = NonNullable<Awaited<ReturnType<typeof reportRoadmap>>>
    export type ReportRoadmapMutationBody = ReportRoadmapBody
    export type ReportRoadmapMutationError = ReportRoadmap400 | ReportRoadmap401 | ReportRoadmap404 | ReportRoadmap500

    /**
 * @summary 로드맵 신고
 */
export const useReportRoadmap = <TError = ReportRoadmap400 | ReportRoadmap401 | ReportRoadmap404 | ReportRoadmap500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportRoadmap>>, TError,{roadmapId: string;data: ReportRoadmapBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof reportRoadmap>>,
        TError,
        {roadmapId: string;data: ReportRoadmapBody},
        TContext
      > => {

      const mutationOptions = getReportRoadmapMutationOptions(options);

      return useMutation(mutationOptions);
    }
    